import webApi, { baseURL } from "../../WebApi/WebApi";

//FETCHING INDUSTRY LIST

export const getAllIndustrylist = async (data) => {
    return await webApi.get('/customer/industry/list-industry');
}

//INDUSTRY LISTING
export const getAllIndustryDetailslist = async (data='', array=[]) => {
    // console.log(data, array, "sdsdsd")
    return await webApi.post(`/customer/business-unit/get-business-unit-list?searchKeyword=${data}`,
        {
            departmentList: array,
            // listType: "all",
        });
}

//INDUSTRY DETAILS BY ID
export const getIndustryById = async (data) => {
    // console.log(data, "datata")
    return await webApi.post(`/customer/business-unit/get-business-unit-by-id/`,
        {
            businessUnitId: data
        });
}


//ADD BUSINESS UNIT

export const getBusinessUnit = async (businessUnitName, shortName,
    identificationNumber, accountingKey,
    industryId, country, state, city, pinCode, address, onSuccess, onFailure) => {
    try {
        const res = await webApi.post(
            `/customer/business-unit/add-business-unit`, {
            name: businessUnitName,
            shortName: shortName,
            buIdentificationNumber: identificationNumber,
            accountingKey: accountingKey,
            industryId: industryId,
            country: country,
            state: state,
            city: city,
            zipcode: pinCode,
            address: address
        }
        );
        if (res.status === 200) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
        // console.log("fdgdf")
    }
};


//update business unit

export const getUpdateBusinessUnit = async (businessUnitName, shortName,
    identificationNumber, accountingKey,
    industryId, country, state, city, pinCode, address, id, onSuccess, onFailure) => {
    try {
        const res = await webApi.post(
            `/customer/business-unit/edit-business-unit`, {
            name: businessUnitName,
            shortName: shortName,
            buIdentificationNumber: identificationNumber,
            accountingKey: accountingKey,
            industryId: industryId,
            country: country,
            state: state,
            city: city,
            zipcode: pinCode,
            address: address,
            id: id,
        }
        );
        if (res.status === 200) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
        // console.log("fdgdf")
    }
};


export const getActiveBusinessUnit = async (module,id,isactive, onSuccess, onFailure) => {
    try {
        const res = await webApi.post(
            `/customer/common/is-active`, {

            "module": module,
            "id": id,
            "isActive": isactive

        }
        );
        if (res.status === 200) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
        // console.log("fdgdf")
    }
};